import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { parseEntityId } from '../entity'
import moment from 'moment'

class CpaPresunta {
  static getCpaPresunta () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cpa_presunta_listado?r=` +
      `{"orden":["fecha_cupo"]}`
    )
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  static getCpaPresuntaTotalizadora () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cpa_presunta_totalizadora`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  static getById (numero = null, codigoCupo = null) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/carta_de_porte_automotor_presunta?r=` +
      `{"clave":{"numero":${JSON.stringify(numero)}, "codigo_cupo": ${JSON.stringify(codigoCupo)}}, "orden":["fecha_informado_stopq"], "limite":1}`)
    return promise.then(lrsAdapter)
      .then(response => (response.data[0] || {}))
      .catch(lrsAdapter)
  }

  static adaptToBackend (values = {}) {
    const {
      exportador,
      cereal,
      cerealVariedad,
      acoplado,
      camion,
      chofer,
      cpeSecuencia,
      cpeSucursal,
      corredorComprador,
      corredorVendedor,
      cosecha,
      ctg,
      kmRecorridos,
      remitenteComercialProductor,
      remitenteComercialVentaPrimaria,
      remitenteComercialVentaSecundaria,
      localidad,
      pesoBruto,
      pesoNeto,
      pesoTara,
      establecimientoDeOrigen,
      tarifa,
      tarifaReferencia,
      titularDeCupo,
      transportista,
      intermediario,
      vendedor,
      mercadoATermino,
      contrato,
      fechaDeVencimiento,
      intermediarioFlete,
      renspa,
      cuentayorden
    } = values
    return {
      exportador: parseEntityId(exportador),
      cereal: cereal,
      cerealVariedad: cerealVariedad,
      acoplado: acoplado,
      camion: camion,
      chofer: parseEntityId(chofer),
      cpeSecuencia: cpeSecuencia,
      cpeSucursal: cpeSucursal,
      corredorComprador: parseEntityId(corredorComprador),
      corredorVendedor: parseEntityId(corredorVendedor),
      cosecha: cosecha,
      ctg: ctg,
      numero: ctg,
      kmRecorridos: kmRecorridos,
      remitenteComercialProductor: parseEntityId(remitenteComercialProductor),
      remitenteComercialVentaPrimaria: parseEntityId(remitenteComercialVentaPrimaria),
      remitenteComercialVentaSecundaria: parseEntityId(remitenteComercialVentaSecundaria),
      localidad: parseEntityId(localidad),
      pesoBruto: pesoBruto,
      pesoNeto: pesoNeto,
      pesoTara: pesoTara,
      establecimientoDeOrigen: establecimientoDeOrigen,
      tarifa: tarifa,
      tarifadeReferencia: tarifaReferencia,
      titularDeCupo: titularDeCupo,
      transportista: parseEntityId(transportista),
      intermediario: parseEntityId(intermediario),
      vendedor: parseEntityId(vendedor),
      mercadoATermino: parseEntityId(mercadoATermino),
      contrato: contrato,
      fechaDeVencimiento: moment(fechaDeVencimiento).format('DD-MM-YYYY HH:mm:ss'),
      intermediarioFlete: parseEntityId(intermediarioFlete),
      renspa: renspa,
      cuentayorden: cuentayorden
    }
  }

  static updateCpaPresunta (codigoCupo, formValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(formValues)
    console.log('valores ', valores)
    const promise = axios.put(`/carta_de_porte_automotor_presunta`, { valores: { ...valores }, clave: { codigo_cupo: codigoCupo } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }
}

export default CpaPresunta
